// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".app[data-v-add142d4]{min-height:100%;display:flex;flex-direction:column}.main[data-v-add142d4]{display:flex;flex-direction:column;flex-grow:1}@media(max-width: 700px){.main[data-v-add142d4]{min-height:calc(100vh - 251px)}}.category-fix[data-v-add142d4]{transition:.2s}.category-fix.hide[data-v-add142d4]{transform:translateY(-72px)}.category-fix.hide_full[data-v-add142d4]{transform:translateY(-100%)}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
